module.exports = {
    tag: 'wonder',
    quality: 1.0,
    regeneration: 1.5,
    speed: 0.5,
    magicalGravity: 0.7
};